import React from 'react'
import { Dialog,Pane } from 'evergreen-ui';
function DeleteResidentBtn() {
    const [isShown, setIsShown] = React.useState(false)
  return (
    <div>

    <Pane>
        <Dialog
            isShown={isShown}
            title="Delete Resident"
            intent="danger"
            onCloseComplete={() => setIsShown(false)}
            confirmLabel="Delete"
        >
            Are you sure you want to delete this resident?
        </Dialog>

        <button type='button' className='btn btn-flat center' onClick={() => setIsShown(true)}>
            <i className='material-icons red-text'>delete</i>
        </button>
    </Pane>

    </div>
  )
}

export default DeleteResidentBtn